//domain.js
import request from '@/utils/request';

export function getDomain(forum_id) {
  return request({
    url: '/v1/forum_info/' + forum_id + '/forum_domain',
    method: 'get',
  });
}
